import { Result } from 'antd'
import styled from 'styled-components'

export const Root = styled(Result)`
  width: '100%';
  height: '100%';
  display: 'flex';
  align-items: 'center';
  justify-content: 'center';
`
